
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import detailContent from '@/views/orderDetail/detailContent.vue'
import rejectDialog from '@/views/Ticket/components/rejectDialog.vue'
import finishedDialog from '@/views/Ticket/components/finishedDialog.vue'
import forwardDialog from '@/views/Ticket/components/forwardDialog.vue'
import editDialog from '@/views/Ticket/components/editDialog.vue'
import rateDialog from '@/views/rate/rateDialog.vue'
import PendingDialog from '@/views/Ticket/components/pendingDialog.vue'
import UnpendingDialog from '@/views/Ticket/components/unpendingDialog.vue'
import { setuserCurrentApp, setuserCurrentAppName } from '@/utils/cookies'
@Component({
  name: 'OrderDetail',
  components: {
    detailContent,
    rejectDialog,
    finishedDialog,
    forwardDialog,
    editDialog,
    rateDialog,
    PendingDialog,
    UnpendingDialog
  }
})
export default class extends Vue {
  created() {
    this.setUserCurrentApp()
  }

  private setUserCurrentApp() {
    const appId = this.$route.query.appid as string
    const appName = this.$route.query.appName as string
    if (appId && appName) {
      setuserCurrentApp(appId)
      setuserCurrentAppName(appName)
    }
  }

  // 子组件接口调用成功后；
  private handleSuccess(res: any) {
    if (res.stat) {
      this.$refs.detailContent && (this.$refs.detailContent as any).handleDetail(this.$route.params.tid, this.$route.params.ticketType)
      if (res.data) {
        this.$message({
          message: res.data,
          type: 'success'
        })
        this.$router.replace({ name: 'home' })
      }
    }
  }
}
